import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css';
import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js';
import {swiperMultistep, apiService} from './tariff_api.es6';
const heic2any = require("heic2any");
import { DotLottie } from '@lottiefiles/dotlottie-web';

// Selectors
const SELECTORS = {
    LOADER: '#loader-ai',
    RESULT_POPUP: '#result-popup',
    AI_BOX: '.nf-field-container.-ai-box',
    MULTISTEP_SLIDE: '.multistep-slider .slide',
    MULTISTEP_FORM_DIV: '.multi-step_form',
    HOUSENUMBER_FIELD: '[name="housenumber"]',
    HOUSENUMBER_ADDITIONAL_FIELD: '[name="housenumberAddition"]',
    AI_BLOCK: '.simple-checkbox.-ai-box'
};

class AiMultistep {
    constructor() {
        this._loading = false; // Internal loading state
        this._loaderAnim = null;
        this.onLoadingChange = null; // Callback for loading state changes
        this.loading = false;
        this.uploadedFiles = [];
        this.uploadedPhotos = [];
        this.filledFields = 0;
        this.fieldMapping = {
            'first-name': 'firstname',
            'housenumber': 'housenumber',
            'last-name': 'lastname',
            'meter-number': 'deliveryPointMeteringDeviceNumber',
            'old-supplier': 'oldSupplier',
            'previous-customer-number': 'oldSupplierCustomerNumber',
            'salutation': 'salutation',
            'street': 'street',
            'market-location-id': 'marketLocation',
        };

        this.initializeForm();
        this.setupAiBlock(SELECTORS.AI_BLOCK);
    }

    // Return loader text based on current percentage
    getLoaderInfoTextByPercent(percent) {
        const p = parseInt(percent, 10) || 0;

        if (p >= 1 && p <= 18) return 'Anschrift erfassen';
        if (p >= 19 && p <= 41) return 'Lieferstelle erfassen';
        if (p >= 42 && p <= 60) return 'Zählernumer suchen';
        if (p >= 61 && p <= 84) return 'Marktlokations-ID identifizieren';
        if (p >= 85 && p <= 100) return 'Daten übergeben';

        return '';
    }

    setupAiBlock(block) {
        $(block).each( function(i) {
            const lottieCanvasBox = $(this).find('.lottie-canvas');
            const lottieCanvas = lottieCanvasBox.find('canvas');

            if (lottieCanvas.length > 0) {
                const lottieSrc = lottieCanvas.data('src');
                const lottieLoop = lottieCanvas.data('loop');

                const dotLottie = new DotLottie({
                    autoplay: true,
                    loop: lottieLoop,
                    canvas: lottieCanvas[0],
                    src: lottieSrc
                });
            }
        });
    }

    getCurrentLoaderPercent() {
        const raw = ($('#loader-ai .percentage').text() || '').replace('%', '').trim();
        const p = parseInt(raw, 10);
        return Number.isFinite(p) ? p : 0;
    }

    setLoaderUI(percent) {
        const p = Math.max(0, Math.min(100, Math.round(percent)));
        $('#loader-ai .percentage').text(`${p}%`);

        this.ensureProcessInfoSlider();
        this.animateProcessInfoTo(p, 320);
    }

    resetProcessInfoSlider() {
        const $info = $('#loader-ai .process-info');
        $info.removeData('pi-slider-init');
        $info.removeData('pi-animating');
        $info.removeData('pi-active-key');
        $info.removeData('pi-pending-key');
        $info.empty();
    }

    stopLoaderAnimation(snapPercent = null) {
        if (!this._loaderAnim) return;

        cancelAnimationFrame(this._loaderAnim.rafId);
        this._loaderAnim.rafId = null;

        if (snapPercent !== null) {
            this.setLoaderUI(snapPercent);
        }

        if (typeof this._loaderAnim.resolve === 'function') {
            this._loaderAnim.resolve(true);
        }

        this._loaderAnim = null;
    }

    startLoaderAnimation(targetPercent, durationMs = 800) {
        this.stopLoaderAnimation();

        const from = this.getCurrentLoaderPercent();
        const to = Math.max(0, Math.min(100, parseInt(targetPercent, 10) || 0));
        const dur = Math.max(50, parseInt(durationMs, 10) || 0);

        const start = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();

        let resolveFn;
        const promise = new Promise((resolve) => { resolveFn = resolve; });

        const tick = () => {
            const now = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
            const t = Math.min(1, (now - start) / dur);
            const val = from + (to - from) * t;

            this.setLoaderUI(val);

            if (t >= 1) {
                this.setLoaderUI(to);
                this._loaderAnim = null;
                resolveFn(true);
                return;
            }

            if (this._loaderAnim) {
                this._loaderAnim.rafId = requestAnimationFrame(tick);
            }
        };

        this._loaderAnim = {
            rafId: requestAnimationFrame(tick),
            resolve: resolveFn
        };

        return {
            promise,
            stop: (snap = null) => this.stopLoaderAnimation(snap),
        };
    }

    async runLoaderSegment(toPercent, durationMs, taskPromise) {
        const anim = this.startLoaderAnimation(toPercent, durationMs);

        try {
            const result = await taskPromise;
            anim.stop(toPercent);
            await anim.promise;
            return result;
        } catch (e) {
            anim.stop();
            throw e;
        }
    }

    ensureProcessInfoSlider() {
        const $info = $('#loader-ai .process-info');

        if ($info.data('pi-slider-init')) return;
        $info.data('pi-slider-init', true);

        // Build all states once
        $info.empty();

        const items = [
            { key: '1-18',  from: 1,  to: 18,  text: 'Anschrift erfassen' },
            { key: '19-41', from: 19, to: 41,  text: 'Lieferstelle erfassen' },
            { key: '42-60', from: 42, to: 60,  text: 'Zählernumer suchen' },
            { key: '61-84', from: 61, to: 84,  text: 'Marktlokations-ID identifizieren' },
            { key: '85-100',from: 85, to: 100, text: 'Daten übergeben' },
        ];

        items.forEach((item) => {
            const $el = $(`<span class="pi-item" data-from="${item.from}" data-to="${item.to}" data-key="${item.key}">${item.text}</span>`);
            $el.css({ transform: 'translateY(100%)' }); // start below
            $info.append($el);
        });

        // State
        $info.data('pi-animating', false);
        $info.data('pi-active-key', null);
        $info.data('pi-pending-key', null);
    }

    getProcessKeyByPercent(percent) {
        const p = parseInt(percent, 10) || 0;

        if (p >= 1 && p <= 18) return '1-18';
        if (p >= 19 && p <= 41) return '19-41';
        if (p >= 42 && p <= 60) return '42-60';
        if (p >= 61 && p <= 84) return '61-84';
        if (p >= 85 && p <= 100) return '85-100';

        return null;
    }

    animateProcessInfoTo(percent, durationMs = 320) {
        const $info = $('#loader-ai .process-info');
        this.ensureProcessInfoSlider();

        const nextKey = this.getProcessKeyByPercent(percent);
        if (!nextKey) return;

        const activeKey = $info.data('pi-active-key');
        if (nextKey === activeKey) return;

        // If animation in progress -> remember what we want next and exit
        if ($info.data('pi-animating')) {
            $info.data('pi-pending-key', nextKey);
            return;
        }

        const $current = activeKey ? $info.find(`.pi-item[data-key="${activeKey}"]`) : $();
        const $next = $info.find(`.pi-item[data-key="${nextKey}"]`);

        if (!$next.length) return;

        $info.data('pi-animating', true);

        // Prepare next below
        $next.stop(true, true).css({ transform: 'translateY(100%)' });

        // Animate current out (if exists)
        if ($current.length) {
            $current.stop(true).animate(
                { dummy: 1 },
                {
                    duration: durationMs,
                    step: (now, fx) => {
                        const k = fx.pos; // 0..1
                        $current.css('transform', `translateY(${-100 * k}%)`);
                        $next.css('transform', `translateY(${100 - 100 * k}%)`);
                    },
                }
            );
        }

        // If there is no current (first show) -> just animate next in
        const animInOnly = () => {
            $next.stop(true).animate(
                { dummy: 1 },
                {
                    duration: durationMs,
                    step: (now, fx) => {
                        const k = fx.pos; // 0..1
                        $next.css('transform', `translateY(${100 - 100 * k}%)`);
                    },
                }
            );
        };

        // We need a single completion point
        const finalize = () => {
            if ($current.length) {
                $current.css({ transform: 'translateY(-100%)' });
            }
            $next.css({ transform: 'translateY(0%)' });

            $info.data('pi-active-key', nextKey);
            $info.data('pi-animating', false);

            // If something was requested while animating -> run it now
            const pendingKey = $info.data('pi-pending-key');
            if (pendingKey && pendingKey !== nextKey) {
                $info.data('pi-pending-key', null);

                // call again using a fake percent by key
                // simplest: map key -> representative percent
                const keyToPercent = {
                    '1-18': 1,
                    '19-41': 19,
                    '42-60': 42,
                    '61-84': 61,
                    '85-100': 85
                };

                this.animateProcessInfoTo(keyToPercent[pendingKey], durationMs);
            } else {
                $info.data('pi-pending-key', null);
            }
        };

        // If first show: only animate next in, then finalize
        if (!$current.length) {
            animInOnly();
            setTimeout(finalize, durationMs);
            return;
        }

        // Normal case: both move, finalize after duration
        setTimeout(finalize, durationMs);
    }

    // Getter for loading state
    get loading() {
        return this._loading;
    }

    // Setter for loading state with additional logic
    set loading(value) {
        if (this._loading !== value) {
            this._loading = value;
            // Trigger callback if defined
            if (typeof this.onLoadingChange === "function") {
                this.onLoadingChange(value);
            }
        }
    }

    // Initialize form logic
    initializeForm() {
        return new Promise((resolve, reject) => {
            try {
                this.initializeUploader();
                this.initializeMobUploader();
                resolve();
            } catch (error) {
                reject('Failed to setup uploader.');
            }
        });
    }

    initializeUploader() {
        const popup = document.getElementById('popup-file-uploader-desktop');
        const dropZone = document.getElementById('drop-zone');
        const addMoreArea = popup.querySelector('.add-more-area');
        const uploadArea = popup.querySelector('.upload-area');
        const addMore = popup.querySelector('.add-more');
        const fileInput = document.getElementById('file-input');

        if (!popup || !dropZone || !fileInput) return;

        // trigger file input on click
        dropZone.addEventListener('click', () => fileInput.click());

        // handle manual file input
        fileInput.addEventListener('change', (e) => {
            if (e.target.files.length > 0) {
                this.handleUploadedFile(e.target.files[0], e.target);
            }
        });

        // centralized drag events
        ['dragenter', 'dragover'].forEach(eventName => {
            popup.addEventListener(eventName, (e) => {
                e.preventDefault();
                e.stopPropagation();

                const isOpen = popup.classList.contains('-open');
                const isUploadVisible = !uploadArea.classList.contains('-hidden');
                const isAddMoreVisible = addMoreArea.classList.contains('-visible');

                if (isOpen && isUploadVisible) {
                    dropZone.classList.add('dragover');
                }

                if (isOpen && isAddMoreVisible) {
                    addMore.classList.add('dragover');
                }

                popup.classList.add('drag-overlay'); // optional full-area overlay
            });
        });

        ['dragleave', 'drop'].forEach(eventName => {
            popup.addEventListener(eventName, (e) => {
                e.preventDefault();
                e.stopPropagation();

                dropZone.classList.remove('dragover');
                addMore.classList.remove('dragover');
                popup.classList.remove('drag-overlay');
            });
        });

        popup.addEventListener('drop', (e) => {
            e.preventDefault();
            const files = e.dataTransfer.files;
            if (files.length > 0) {
                this.handleUploadedFile(files[0], fileInput);
            }
        });
    }

    initializeMobUploader() {
        const fileInputMob = document.getElementById('file-input-mob');
        const photoInputMob = document.getElementById('file-photo-mob');
        const addPhoto = document.getElementById('add-photo');

        if (!fileInputMob) return;

        fileInputMob.addEventListener('change', (e) => {
            if (e.target.files.length > 0) {
                this.handleUploadedFileMob(e.target.files[0], e.target);
            }
        });

        photoInputMob.addEventListener('change', (e) => {
            if (e.target.files.length > 0) {
                this.handleUploadedPhotoMob(e.target.files[0], e.target);
            }
        });

        addPhoto.addEventListener('click', () => photoInputMob.click());
    }

    async convertHeicIfNeeded(file) {
        const isHeic = file.type === 'image/heic' || file.name.toLowerCase().endsWith('.heic');

        if (!isHeic) return file;

        try {
            const convertedBlob = await heic2any({
                blob: file,
                toType: 'image/png',
                quality: 0.9,
            });

            const convertedFile = new File(
                [convertedBlob],
                file.name.replace(/\.heic$/i, '.png'),
                { type: 'image/png' }
            );

            console.log('✅ HEIC converted:', convertedFile.name);
            return convertedFile;
        } catch (error) {
            console.error('❌ HEIC conversion failed:', error);
            return file;
        }
    }

    handleUploadedFile(file, input) {
        const allowedMimeTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/heic', 'image/heif'];
        const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png', '.heic', '.heif'];
        const maxSize = 20 * 1024 * 1024;

        const fileName = file.name.toLowerCase();
        const fileExtension = fileName.substring(fileName.lastIndexOf('.'));
        const fileType = file.type || '';
        const popupUpload = $('#popup-file-uploader-desktop');

        const responseErrorsUploads = $('#popup-file-uploader-desktop .response-errors-uploads');
        const uploadDescription = $('#popup-file-uploader-desktop .drop-zone .upload-description');
        const uploadHeading = $('#popup-file-uploader-desktop .upload-area .upload-heading');
        const iconSvg = $('#popup-file-uploader-desktop .drop-zone .icon');

        const uploadArea = popupUpload.find('.upload-area');
        const addMoreArea = popupUpload.find('.add-more-area');

        const isAllowed =
            allowedMimeTypes.includes(fileType) ||
            allowedExtensions.includes(fileExtension);

        if (!isAllowed) {
            console.error('❌ [handleUploadedFile] not allowed file type')
            responseErrorsUploads.html('<div class="error">Dateiformat nicht erkannt</div><div class="hint">Bitte versuche es mit einer anderen Datei.</div>');
            uploadDescription.html('Ziehe Deine Dateien hier her oder lade sie hoch');
            uploadHeading.html('Deine Uploads');
            iconSvg.html('<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '<path fill-rule="evenodd" clip-rule="evenodd" d="M18.457 20.707C18.0665 21.0975 17.4335 21.0975 17.043 20.707C16.6524 20.3164 16.6524 19.6834 17.043 19.2929L23.293 13.0429C23.6835 12.6524 24.3165 12.6524 24.707 13.0429L30.957 19.2929L31.0254 19.3691C31.3457 19.7618 31.3231 20.3408 30.957 20.707C30.5909 21.0731 30.0119 21.0957 29.6191 20.7753L29.543 20.707L25 16.164L25 26.9999C25 27.5522 24.5523 27.9999 24 27.9999C23.4477 27.9999 23 27.5522 23 26.9999L23 16.164L18.457 20.707ZM13 31.8749V29.3749C13 28.8226 13.4477 28.3749 14 28.3749C14.5523 28.3749 15 28.8226 15 29.3749V31.8749L15.0078 32.0234C15.042 32.3667 15.1934 32.6894 15.4395 32.9355C15.7208 33.2168 16.1022 33.3749 16.5 33.3749H31.5C31.8978 33.3749 32.2792 33.2168 32.5605 32.9355C32.8419 32.6542 33 32.2727 33 31.8749V29.3749C33 28.8226 33.4477 28.3749 34 28.3749C34.5523 28.3749 35 28.8226 35 29.3749V31.8749C35 32.8032 34.631 33.6932 33.9746 34.3495C33.3182 35.0059 32.4283 35.3749 31.5 35.3749H16.5C15.5717 35.3749 14.6818 35.0059 14.0254 34.3495C13.4101 33.7342 13.0469 32.9137 13.0039 32.0488L13 31.8749Z" fill="#E7E7E7"/>\n' +
                '</svg>');

            uploadArea.removeClass('-hidden');
            addMoreArea.removeClass('-visible');
            return;
        }

        if (file.size > maxSize) {
            responseErrorsUploads.html('<div class="error">Deine Datei ist zu groß</div><div class="hint">Die Datei darf nicht größer als 20 MB sein.</div>');
            uploadDescription.html('Ziehe Deine Dateien hier her oder lade sie hoch');
            uploadHeading.html('Deine Uploads');
            iconSvg.html('<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                '<path fill-rule="evenodd" clip-rule="evenodd" d="M18.457 20.707C18.0665 21.0975 17.4335 21.0975 17.043 20.707C16.6524 20.3164 16.6524 19.6834 17.043 19.2929L23.293 13.0429C23.6835 12.6524 24.3165 12.6524 24.707 13.0429L30.957 19.2929L31.0254 19.3691C31.3457 19.7618 31.3231 20.3408 30.957 20.707C30.5909 21.0731 30.0119 21.0957 29.6191 20.7753L29.543 20.707L25 16.164L25 26.9999C25 27.5522 24.5523 27.9999 24 27.9999C23.4477 27.9999 23 27.5522 23 26.9999L23 16.164L18.457 20.707ZM13 31.8749V29.3749C13 28.8226 13.4477 28.3749 14 28.3749C14.5523 28.3749 15 28.8226 15 29.3749V31.8749L15.0078 32.0234C15.042 32.3667 15.1934 32.6894 15.4395 32.9355C15.7208 33.2168 16.1022 33.3749 16.5 33.3749H31.5C31.8978 33.3749 32.2792 33.2168 32.5605 32.9355C32.8419 32.6542 33 32.2727 33 31.8749V29.3749C33 28.8226 33.4477 28.3749 34 28.3749C34.5523 28.3749 35 28.8226 35 29.3749V31.8749C35 32.8032 34.631 33.6932 33.9746 34.3495C33.3182 35.0059 32.4283 35.3749 31.5 35.3749H16.5C15.5717 35.3749 14.6818 35.0059 14.0254 34.3495C13.4101 33.7342 13.0469 32.9137 13.0039 32.0488L13 31.8749Z" fill="#E7E7E7"/>\n' +
                '</svg>');

            uploadArea.removeClass('-hidden');
            addMoreArea.removeClass('-visible');
            return;
        }

        responseErrorsUploads.empty();
        uploadDescription.html('Lege Deine Dateien in diesem Feld ab oder wähle sie manuell aus.');
        uploadHeading.html('Datei hochladen');
        iconSvg.html('<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.667 33.333V14.667C13.667 12.6419 15.3089 11 17.334 11H26.667C26.6813 11 26.6956 11.0003 26.7098 11.0009C26.9738 11.012 27.2114 11.1255 27.3838 11.3028L34.041 17.96C34.2283 18.1475 34.334 18.4019 34.334 18.667V33.333C34.334 35.3581 32.692 37 30.667 37H17.334C15.3089 37 13.667 35.3581 13.667 33.333ZM25.667 13H17.334C16.4135 13 15.667 13.7465 15.667 14.667V33.333C15.667 34.2535 16.4135 35 17.334 35H30.667C31.5875 35 32.334 34.2535 32.334 33.333V19.667H28C26.7115 19.6668 25.667 18.6216 25.667 17.333V13ZM30.9199 17.667H28C27.8161 17.6668 27.667 17.517 27.667 17.333V14.4141L30.9199 17.667ZM28.1028 24.3385L28.0003 24.3336H20.0003C19.448 24.3336 19.0003 24.7813 19.0003 25.3336C19.0005 25.8858 19.4481 26.3336 20.0003 26.3336H28.0003L28.1028 26.3278C28.6068 26.2764 29.0001 25.8511 29.0003 25.3336C29.0003 24.816 28.607 24.3898 28.1028 24.3385ZM28.1028 29.6719L28.0003 29.667H20.0003C19.448 29.667 19.0003 30.1147 19.0003 30.667C19.0005 31.2191 19.4481 31.667 20.0003 31.667H28.0003L28.1028 31.6611C28.6068 31.6098 29.0001 31.1845 29.0003 30.667C29.0003 30.1493 28.607 29.7232 28.1028 29.6719Z" fill="#E7E7E7"/></svg>');

        // 2. Показати початковий прогрес
        this.showUploadProgress(file, 'desktop');



        const total = file.size;
        const totalKB = (total / 1024).toFixed(0);

        const fileSizeKB = file.size / 1024;
        let duration = 500 + ((fileSizeKB - 1) * (3000 - 500)) / (20480 - 1);

        if (fileSizeKB <= 1) {
            duration = 500;
        } else if (fileSizeKB >= 20480) {
            duration = 3000;
        }

        if (['.heic', '.heif'].includes(fileExtension)) {
            duration *= 4;
        }

        const steps = 100; // кількість кадрів
        const interval = duration / steps;
        let step = 0;

        const convertedFilePromise = this.convertHeicIfNeeded(file); // запускаємо одразу

        let isConversionDone = false;
        let isAnimationDone = false;

        const onBothDone = async () => {
            if (!isConversionDone || !isAnimationDone) return;

            const convertedFile = await convertedFilePromise;
            const reader = new FileReader();
            reader.onload = () => {
                const base64 = reader.result.split(',')[1];

                this.uploadedFiles.push({
                    name: convertedFile.name,
                    data: convertedFile,
                    size: convertedFile.size,
                    type: convertedFile.type,
                    base64: base64
                });

                this.hideUploadProgress('desktop');
                this.renderUploadedFilesUI();
            };
            reader.readAsDataURL(convertedFile);
        };

        const timer = setInterval(() => {
            step++;
            const percent = Math.min((step / steps) * 100, 100);
            const loaded = Math.floor((percent / 100) * total);
            const loadedKB = (loaded / 1024).toFixed(0);

            $('.file-uploading .file-size').text(`${loadedKB} KB von ${totalKB} KB`);
            $('.progress-line .filled').css('width', `${percent}%`);

            if (step >= steps) {
                isAnimationDone = true;
                clearInterval(timer);
                onBothDone();
            }
        }, interval);

        convertedFilePromise.then(() => {
            isConversionDone = true;
            onBothDone();

            setTimeout(() => {
                input.value = '';
            }, 0);
        });
    }

    handleUploadedFileMob(file) {
        const allowedMimeTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/heic', 'image/heif'];
        const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png', '.heic', '.heif'];
        const maxSize = 20 * 1024 * 1024;

        const fileName = file.name.toLowerCase();
        const fileExtension = fileName.substring(fileName.lastIndexOf('.'));
        const fileType = file.type || '';

        const responseErrorsUploads = $('#popup-file-uploader-mobile .response-errors-uploads');
        const uploadDescription = $('#popup-file-uploader-mobile .upload-description');
        const uploadHeading = $('#popup-file-uploader-mobile .upload-area .upload-heading');

        const isAllowed =
            allowedMimeTypes.includes(fileType) ||
            allowedExtensions.includes(fileExtension);

        if (!isAllowed) {
            responseErrorsUploads.html('<div class="error">Dateiformat nicht erkannt</div><div class="hint">Bitte versuche es mit einer anderen Datei.</div>');
            uploadDescription.hide();
            uploadHeading.html('Deine Uploads').css('text-align', 'left');
            return;
        }

        if (file.size > maxSize) {
            responseErrorsUploads.html('<div class="error">Deine Datei ist zu groß</div><div class="hint">Die Datei darf nicht größer als 20 MB sein.</div>');
            uploadDescription.hide();
            uploadHeading.html('Deine Uploads').css('text-align', 'left');
            return;
        }

        responseErrorsUploads.empty();
        uploadDescription.show();
        uploadHeading.html('Datei hochladen').css('text-align', 'center');

        // 2. Показати початковий прогрес
        this.showUploadProgress(file, 'mobile');



        const total = file.size;
        const totalKB = (total / 1024).toFixed(0);

        const fileSizeKB = file.size / 1024;
        let duration = 500 + ((fileSizeKB - 1) * (3000 - 500)) / (20480 - 1);

        if (fileSizeKB <= 1) {
            duration = 500;
        } else if (fileSizeKB >= 20480) {
            duration = 3000;
        }

        const steps = 100; // кількість кадрів
        const interval = duration / steps;
        let step = 0;

        const timer = setInterval(async () => {
            step++;
            const percent = Math.min((step / steps) * 100, 100);
            const loaded = Math.floor((percent / 100) * total);
            const loadedKB = (loaded / 1024).toFixed(0);

            $('.file-uploading .file-size').text(`${loadedKB} KB von ${totalKB} KB`);
            $('.progress-line .filled').css('width', `${percent}%`);

            if (step >= steps) {
                clearInterval(timer);

                const convertedFile = await this.convertHeicIfNeeded(file);

                const reader = new FileReader();
                reader.onload = () => {
                    const base64 = reader.result.split(',')[1];

                    this.uploadedFiles.push({
                        name: convertedFile.name,
                        data: convertedFile,
                        size: convertedFile.size,
                        type: convertedFile.type,
                        base64: base64
                    });

                    this.hideUploadProgress('mobile');
                    this.renderUploadedFilesUI();
                };
                reader.readAsDataURL(convertedFile);
            }
        }, interval);
    }

    async handleUploadedPhotoMob(file, input) {
        const allowedMimeTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/heic', 'image/heif'];
        const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png', '.heic', '.heif'];
        const maxSize = 20 * 1024 * 1024;

        const fileName = file.name.toLowerCase();
        const fileExtension = fileName.substring(fileName.lastIndexOf('.'));
        const fileType = file.type || '';

        const responseErrorsUploads = $('#popup-file-uploader-mobile .response-errors-uploads');
        const uploadDescription = $('#popup-file-uploader-mobile .upload-description');
        const uploadHeading = $('#popup-file-uploader-mobile .upload-area .upload-heading');

        const isAllowed =
            allowedMimeTypes.includes(fileType) ||
            allowedExtensions.includes(fileExtension);

        if (!isAllowed) {
            responseErrorsUploads.html('<div class="error">Dateiformat nicht erkannt</div><div class="hint">Bitte versuche es mit einer anderen Datei.</div>');
            uploadDescription.hide();
            uploadHeading.html('Deine Uploads').css('text-align', 'left');
            return;
        }

        if (file.size > maxSize) {
            responseErrorsUploads.html('<div class="error">Deine Datei ist zu groß</div><div class="hint">Die Datei darf nicht größer als 20 MB sein.</div>');
            uploadDescription.hide();
            uploadHeading.html('Deine Uploads').css('text-align', 'left');
            return;
        }

        if (!file || !(file instanceof File) || file.size === 0 || !file.name) {
            responseErrorsUploads.html('<div class="error">Ein Fehler ist aufgetreten</div><div class="hint">Wir konnten Dein Foto nicht hochladen. Bitte versuche es erneut oder lade ein Dokument hoch.</div>');
            uploadDescription.hide();
            uploadHeading.html('Deine Uploads').css('text-align', 'left');
            return;
        }

        responseErrorsUploads.empty();
        uploadDescription.show();
        uploadHeading.html('Datei hochladen').css('text-align', 'center');

        // 2. Показати початковий прогрес
        this.showUploadProgress(file, 'mobile', true);

        const isHeic = file.type === 'image/heic' || file.name.toLowerCase().endsWith('.heic');
        const total = file.size;
        const totalKB = (total / 1024).toFixed(0);

        const steps = 100;
        let step = 0;

        // 🟡 Запускаємо конвертацію одразу (асинхронно)
        const convertPromise = this.convertHeicIfNeeded(file);

        // 🟡 Одночасно запускаємо таймер прогресу
        const duration = isHeic ? 4000 : 2000;
        const interval = duration / steps;

        const timerPromise = new Promise((resolve) => {
            const timer = setInterval(() => {
                step++;
                const percent = Math.min((step / steps) * 100, 100);
                const loaded = Math.floor((percent / 100) * total);
                const loadedKB = (loaded / 1024).toFixed(0);

                $('.file-uploading .file-size').text(`${loadedKB} KB von ${totalKB} KB`);
                $('.progress-line .filled').css('width', `${percent}%`);

                if (step >= steps) {
                    clearInterval(timer);
                    resolve();
                }
            }, interval);
        });

        // 🟢 Чекаємо завершення і конвертації, і анімації
        const convertedFile = await convertPromise;
        await timerPromise;

        const reader = new FileReader();
        reader.onload = () => {
            const base64 = reader.result.split(',')[1];

            this.uploadedPhotos.push({
                name: convertedFile.name,
                data: convertedFile,
                size: convertedFile.size,
                type: convertedFile.type,
                base64: base64
            });

            this.showPhotoArea();
        };
        reader.readAsDataURL(convertedFile);

        setTimeout(() => {
            input.value = '';
        }, 0);
    }

    showUploadBox() {
        const initBox = $('.upload-area');
        const hiddenBox = $('.hidden-upload-box');

        initBox.removeClass('-hidden');
        hiddenBox.removeClass('-visible');
    }


    renderUploadedFilesUI() {
        const initBox = $('.upload-area');
        const hiddenBox = $('.hidden-upload-box');
        const container = $('.uploaded-files-list');

        container.empty();

        if(this.uploadedFiles.length > 0) {
            this.uploadedFiles.forEach((file, index) => {
                const html = `
                    <div class="upload-entry" data-index="${index}">
                        <div class="file-name text-3">${file.name}</div>
                        <div class="file-size text-3">${(file.size / 1024).toFixed(0)} KB</div>
                        <button class="delete-upload" data-index="${index}"></button>
                    </div>
                `;
                container.append(html);
            });

            if(!initBox.hasClass('-hidden') && !hiddenBox.hasClass('-visible')) {
                initBox.addClass('-hidden');
                hiddenBox.addClass('-visible');
            }
        } else {
            initBox.removeClass('-hidden');
            hiddenBox.removeClass('-visible');
        }
    }

    showUploadProgress(file, device, photo = false) {
        const correctPopup = device === 'desktop'? $('#popup-file-uploader-desktop') : $('#popup-file-uploader-mobile');
        const uploadArea = correctPopup.find('.upload-area');
        const uploadEmptyArea = correctPopup.find('.photo-area-empty');
        const progressArea = correctPopup.find('.progress-area');
        const fileUploading = correctPopup.find('.file-uploading .file-info');
        const fileUploadingBox = correctPopup.find('.file-uploading');
        const photoArea = correctPopup.find('.photo-area');
        const addMoreArea = correctPopup.find('.add-more-area');

        if(photo) {
            fileUploadingBox.addClass('-photo');
        } else {
            fileUploadingBox.removeClass('-photo');
        }

        const html = `
            <div class="file-name text-3">${file.name}</div>
            <div class="file-size text-3">0 KB von ${(file.size / 1024).toFixed(0)} KB</div>
        `;
        fileUploading.html(html);

        if(!progressArea.hasClass('-visible')) {
            uploadArea.addClass('-hidden');
            uploadEmptyArea.removeClass('-visible');
            progressArea.addClass('-visible');
            photoArea.removeClass('-visible');
            addMoreArea.removeClass('-visible');
        }
    }

    hideUploadProgress(device) {
        const popupUpload = device === 'desktop'? $('#popup-file-uploader-desktop') : $('#popup-file-uploader-mobile');
        const uploadArea = popupUpload.find('.upload-area');
        const uploadEmptyArea = popupUpload.find('.photo-area-empty');
        const progressArea = popupUpload.find('.progress-area');
        const progressLineFilled = popupUpload.find('.progress-line .filled');
        const fileUploading = popupUpload.find('.file-uploading .file-info');
        const photoArea = popupUpload.find('.photo-area');
        const addMoreArea = popupUpload.find('.add-more-area');


        progressArea.removeClass('-visible');
        photoArea.removeClass('-visible');

        if(this.uploadedFiles.length > 0) {
            addMoreArea.addClass('-visible');
            uploadArea.addClass('-hidden');
            uploadEmptyArea.removeClass('-visible');
        } else {
            uploadArea.removeClass('-hidden');
            addMoreArea.removeClass('-visible');
            uploadEmptyArea.removeClass('-visible');
        }

        fileUploading.empty();
        progressLineFilled.css('width', `0%`);
    }

    showPhotoArea() {
        const popupUpload = $('#popup-file-uploader-mobile');
        const uploadArea = popupUpload.find('.upload-area');
        const uploadEmptyArea = popupUpload.find('.photo-area-empty');
        const progressArea = popupUpload.find('.progress-area');
        const photoArea = popupUpload.find('.photo-area');
        const countDiv = photoArea.find('.photos-count');

        const container = $('.photos-list');
        const photoItems = container.find('.item-default');
        const photoCount = this.uploadedPhotos.length;

        photoItems.remove();

        if(photoCount > 0) {
            if(photoCount > 1) {
                countDiv.html(`(${photoCount} Fotos)`);
            } else {
                countDiv.html(`(${photoCount} Foto)`);
            }

            let html = '';
            this.uploadedPhotos.forEach((file, index) => {
                html += `
                    <div class="item-default" data-index="${index}" style="background-image: url('data:${file.type};base64,${file.base64}')">
                        <button class="delete-photo" data-index="${index}"></button>
                    </div>
                `;
            });

            const target = container.hasClass('mCustomScrollbar') ? container.find('.mCSB_container') : container;
            target.append(html);

            if (container.hasClass('mCustomScrollbar')) {
                container.mCustomScrollbar('destroy');
            }

            setTimeout(() => {
                if(photoCount > 1) {
                    container.mCustomScrollbar({
                        theme: 'light-thick',
                        axis: 'x',
                        contentTouchScroll: 25,
                        advanced: {
                            updateOnContentResize: true
                        },
                        mouseWheel: {
                            enable: true
                        },
                        callbacks: {
                            onInit: function() {
                                setTimeout(() => {
                                    container.mCustomScrollbar('scrollTo', 'left');
                                }, 10);
                            }
                        }
                    });
                }
            }, 0);

            setTimeout(() => {
                uploadArea.addClass('-hidden');
                uploadEmptyArea.removeClass('-visible');
                progressArea.removeClass('-visible');
                photoArea.addClass('-visible');
            }, 0);
        } else {
            uploadArea.addClass('-hidden');
            uploadEmptyArea.addClass('-visible');
            progressArea.removeClass('-visible');
            photoArea.removeClass('-visible');
        }
    }

    pushPhotos() {
        const popupUpload = $('#popup-file-uploader-mobile');
        const uploadArea = popupUpload.find('.upload-area');
        const progressArea = popupUpload.find('.progress-area');
        const photoArea = popupUpload.find('.photo-area');
        const hiddenBox = popupUpload.find('.hidden-upload-box');


        if (Array.isArray(this.uploadedPhotos) && this.uploadedPhotos.length > 0) {
            this.uploadedPhotos.forEach(photo => {
                this.uploadedFiles.push(photo);
            });

            this.hideUploadProgress('mobile');

            this.renderUploadedFilesUI();

            this.uploadedPhotos = [];

            progressArea.removeClass('-visible');
            photoArea.removeClass('-visible');
            hiddenBox.addClass('-visible');
        }
    }

    showLoader() {
        return new Promise(resolve => {
            $(".upload-popup").removeClass("-open");

            $('#loader-ai').fadeIn(200, () => {
                this.setupAiBlock(SELECTORS.LOADER);
                resolve();
            });
        });
    }


    hideLoader() {
        $('body').removeClass('overflow-hidden');
        $(SELECTORS.LOADER).hide();
        this.resetProcessInfoSlider();
    }

    splitHouseNumber(input) {
        const match = input.match(/^(\d+)([a-zA-Z0-9\/-]*)$/);

        if (!match) {
            return {
                housenumber: input,         // everything if we can’t split
                housenumberAddition: ''
            };
        }

        return {
            housenumber: match[1],
            housenumberAddition: match[2] || ''
        };
    }

    findClosestStreet(inputStreet, options) {
        const normalize = str =>
            str.toLowerCase()
                .replace(/straße/g, 'str')
                .replace(/str\./g, 'str')
                .replace(/ß/g, 'ss')
                .replace(/\./g, '')
                .replace(/-/g, ' ')
                .replace(/\s+/g, ' ')
                .trim();

        const normInput = normalize(inputStreet);

        for (let option of options) {
            if (normalize(option) === normInput) {
                console.log('✅ Exact match:', option);
                return option;
            }
        }

        for (let option of options) {
            if (normalize(option).includes(normInput)) {
                console.log('➕ Partial match:', option);
                return option;
            }
        }

        console.warn('❌ No match for street:', inputStreet);
        return null;
    }

    similarity(str1, str2) {
        const length = Math.max(str1.length, str2.length);
        if (length === 0) return 1;
        let matches = 0;
        for (let i = 0; i < Math.min(str1.length, str2.length); i++) {
            if (str1[i] === str2[i]) matches++;
        }
        return matches / length;
    }

    cleanSupplierName(name) {
        return name.trim().replace(/[^\p{L}\p{N}]+$/u, '');
    }

    applyAiResponseToForm(responseData, mapping = this.fieldMapping) {
        if (typeof responseData !== 'object' || !responseData) return Promise.resolve({});

        const $this = this;
        const asyncTasks = [];

        console.log('📥 [applyAiResponseToForm] AI Data:', responseData);

        let resultForNextStep = {
            postalCode: null,
            city: null,
            defaultStreet: null
        };

        this.filledFields = 0;

        Object.entries(mapping).forEach(([aiKey, fieldName]) => {
            const searchedValue = responseData[aiKey];
            if(searchedValue && searchedValue.value) {
                const value = searchedValue.value;
                if (typeof value !== 'undefined' && value !== null) {
                    const $field = $(`[name="${fieldName}"]`);
                    if ($field.length) {
                        const tag = $field.prop('tagName').toLowerCase();
                        const type = $field.attr('type');

                        console.log(`🧩 [applyAiResponseToForm] Filling field "${fieldName}" with value:`, value);

                        const currentValue = $field.val() ? $field.val().toString().trim() : '';

                        if (currentValue) {
                            console.log(`⚠️ [applyAiResponseToForm] Skipping "${fieldName}" – already has value: "${currentValue}"`);
                            return;
                        }

                        if (aiKey === 'housenumber') {
                            const { housenumber, housenumberAddition } = $this.splitHouseNumber(value);

                            if(housenumber) {
                                $(SELECTORS.HOUSENUMBER_FIELD).val(housenumber).trigger('change');
                                $(SELECTORS.HOUSENUMBER_FIELD).parent().append(`<span class="pseudo-filled">${housenumber}</span>`);
                                $(SELECTORS.HOUSENUMBER_FIELD).closest('.nf-field-container').addClass('ai-changed');
                                this.filledFields++;
                            }

                            if(housenumberAddition) {
                                $(SELECTORS.HOUSENUMBER_ADDITIONAL_FIELD).val(housenumberAddition).trigger('change');
                                $(SELECTORS.HOUSENUMBER_ADDITIONAL_FIELD).parent().append(`<span class="pseudo-filled">${housenumberAddition}</span>`);
                                $(SELECTORS.HOUSENUMBER_ADDITIONAL_FIELD).closest('.nf-field-container').addClass('ai-changed');
                                this.filledFields++;
                            }

                            return;
                        }

                        if (fieldName === 'street') {
                            resultForNextStep.defaultStreet = value;
                            return;
                        }

                        if (tag === 'input' && value) {
                            $field.val(value).trigger('change');
                            $field.parent().append(`<span class="pseudo-filled">${value}</span>`);
                            $field.closest('.nf-field-container').addClass('ai-changed');
                            this.filledFields++;
                        }

                        if (fieldName === 'oldSupplier') {
                            let clearValue = this.cleanSupplierName(value);
                            if(clearValue) {
                                const task = apiService.initializeSupplierSelect2('[name="oldSupplier"]', clearValue)
                                    .then(isSetOldSupplier => {
                                        console.log('isSetOldSupplier: '+isSetOldSupplier);
                                        if (isSetOldSupplier) {
                                            this.filledFields++;
                                            $field.closest('.nf-field-container').addClass('ai-changed');
                                        }
                                    });

                                asyncTasks.push(task);
                            }
                        }

                        if (fieldName === 'salutation') {
                            let matchedValue = null;

                            $field.find('option').each(function () {
                                const optionValue = $(this).val()? $(this).val().trim().toLowerCase() : '';
                                const optionText = $(this).text()? $(this).text().trim().toLowerCase() : '';
                                const inputValue = value.trim().toLowerCase();

                                if (optionValue === inputValue || optionText === inputValue) {
                                    matchedValue = $(this).val();
                                    return false; // break loop
                                }
                            });

                            if (matchedValue) {
                                console.log(`✅ [applyAiResponseToForm] Matched salutation: ${matchedValue}`);
                                $field.val(matchedValue).trigger('change');
                                this.filledFields++;

                                $field.closest('.nf-field-container').addClass('ai-changed');
                            } else {
                                console.warn(`⚠️ [applyAiResponseToForm] No matching salutation found for: ${value}`);
                            }
                        }

                        if ((fieldName === 'deliveryPointMeteringDeviceNumber' || fieldName === 'marketLocation') && value) {
                            $('input[name="meterNumberCheckbox"]').prop('checked', true).trigger('change');
                        }
                    }
                }
            }
        });

        return Promise.all(asyncTasks).then(() => {
            console.log('✅ [applyAiResponseToForm] All async tasks done. filledFields =', this.filledFields);
            return resultForNextStep;
        });
    }

    sendFilesToServer() {
        if (this.uploadedFiles.length === 0) return Promise.resolve();
        let $this = this;

        const filesPayload = this.uploadedFiles.map(file => ({
            name: file.name,
            type: file.type,
            base64: file.base64
        }));

        return new Promise((resolve, reject) => {
            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                method: 'POST',
                dataType: 'json',
                data: {
                    action: 'send_to_google_ai',
                    files: filesPayload
                },
                success: (response) => {
                    if (response.success &&
                        response.data.summary &&
                        typeof response.data.summary === 'object' &&
                        !Array.isArray(response.data.summary) &&
                        Object.keys(response.data.summary).length > 0) {
                        console.log('✅ [sendFilesToServer] Response:', response.data);
                        resolve(response.data);
                    } else {
                        $this.uploadedFiles = [];
                        $this.renderUploadedFilesUI();
                        console.error('❌ [sendFilesToServer] Error:', response.data);
                        reject(response.data);
                    }
                },
                error: (xhr, status, error) => {
                    $this.uploadedFiles = [];
                    $this.renderUploadedFilesUI();
                    console.error('❌ [sendFilesToServer] AJAX error:', error);
                    reject(error);
                }
            });
        });
    }

    updateProgress(percentage, durationMs = 500, infoText = '') {
        const $percentage = $('#loader-ai .percentage');
        const $info = $('#loader-ai .process-info');

        if(percentage !== 0) {
            let current = parseInt(($percentage.text() || '0').replace('%', ''), 10) || 0;
            const target = parseInt(percentage, 10);
            const steps = 30;
            const interval = durationMs / steps;
            const stepValue = (target - current) / steps;

            // If infoText is not provided, we auto-map by percent
            const getInfoText = (p) => infoText ? infoText : this.getLoaderInfoTextByPercent(p);
            let lastInfoText = $info.text();

            let i = 0;
            const intervalId = setInterval(() => {
                current += stepValue;
                const shownPercent = Math.round(current);
                $percentage.text(`${shownPercent}%`);

                const nextInfo = getInfoText(shownPercent);
                if (nextInfo !== lastInfoText) {
                    $info.text(nextInfo);
                    lastInfoText = nextInfo;
                }

                i++;
                if (i >= steps) {
                    clearInterval(intervalId);
                    $percentage.text(`${target}%`);

                    const finalInfo = getInfoText(target);
                    if (finalInfo !== lastInfoText) {
                        $info.text(finalInfo);
                    }
                }
            }, interval);
        } else {
            $percentage.text('0');
            $info.text('');
        }

    }

    updateStreetFieldFromSelect(defaultStreet) {
        const $streetSelect = $('[name="street"]');

        if ($streetSelect.length === 0 || !defaultStreet) {
            console.warn('⚠️ [updateStreetFieldFromSelect] Kein Feld oder Wert');
            return 0;
        }

        const availableStreets = [];
        $streetSelect.find('option').each(function () {
            const val = $(this).val();
            if (val) {
                availableStreets.push(val);
            }
        });

        console.log('📋 [updateStreetFieldFromSelect] Gefundene Optionen:', availableStreets);

        const matchedStreet = aiMultistep.findClosestStreet(defaultStreet, availableStreets);

        if (matchedStreet) {
            $streetSelect.val(matchedStreet).trigger('change');
            $streetSelect.closest('.nf-field-container').addClass('ai-changed');
            $streetSelect.addClass('-filled');
            return 1;
        } else {
            $streetSelect.val('').trigger('change');
            $streetSelect.addClass('-filled');
            return 0;
        }
    }

    openResultPopup(success = false) {
        let resultPopup = $(SELECTORS.RESULT_POPUP);
        let resultPopupContent = resultPopup.find('.modal-content');

        if(success) {
            resultPopupContent.html('<h4 class="text-2">Geschafft! '+this.filledFields+' Felder wurden erfolgreich ergänzt.</h4>\n' +
                '                  <p class="text-2">Bitte ergänze fehlende Angaben und prüfe noch einmal alle Felder, bevor Du den Tarif abschließt.</p>\n' +
                '                  <button class="close-popup btn-cta">verstanden</button>');
        } else {
            resultPopupContent.html('<h4 class="text-2">Tut uns leid.</h4>\n' +
                '                  <p class="text-2">Leider konnten wir keine passenden Daten aus Deinen Dokumenten auslesen</p>\n' +
                '                  <button class="repeat-upload btn-cta repeat-button">erneut versuchen</button>\n' +
                '                  <button class="close-popup btn-link-primary arrow-right new">Angaben manuell eintragen</button>');
        }

        resultPopup.addClass("-open");
        $("body").addClass("overflow-hidden");
    }

    replaceAiBox() {
        const aiBox = $(SELECTORS.AI_BOX);
        const multistepSlides = $(SELECTORS.MULTISTEP_SLIDE);

        // Remove previous AI box if it exists
        aiBox.remove();

        // Define the HTML for the new AI box
        const aiBoxHtml = `
        <div class="nf-field-container html-container -ai-success-box"> 
            <div class="field-wrap html-wrap">
                <div class="nf-field-element">
                    <div class="text-3">
                        Bitte prüfe alle Deine Angaben sorgfältig. Durch fehlerhafte Angaben verlängert sich Dein Wechselprozess.
                    </div> 
                </div>
            </div>
        </div>
    `;

        // Prepend the AI box to the first 3 slides
        multistepSlides.slice(0, 3).each(function () {
            const $backLink = $(this).find('.back-link');

            if ($backLink.length > 0) {
                $backLink.after(aiBoxHtml);
            } else {
                $(this).prepend(aiBoxHtml);
            }
        });
    }

    openUploadPopup() {
        const isMobileCameraCapable = () => {
            const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
            const isSmallScreen = window.innerWidth <= 768;
            const hasCamera = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);

            // return isTouch && isSmallScreen && hasCamera;
            return isTouch && hasCamera;
            // return true;
        };

        if (isMobileCameraCapable()) {
            $('#popup-file-uploader-mobile').addClass('-open');
        } else {
            $('#popup-file-uploader-desktop').addClass('-open');
        }
        $("body").addClass("overflow-hidden");
    }

    estimateUploadTime() {
        const timeForPdf = 12000;   // ms
        const timeForImage = 8000;  // ms
        let estimatedTime = 0;

        if (Array.isArray(this.uploadedFiles)) {
            this.uploadedFiles.forEach(file => {
                const type = file.type || '';
                if (type.includes('pdf')) {
                    estimatedTime += timeForPdf;
                } else if (type.includes('image')) {
                    estimatedTime += timeForImage;
                } else {
                    estimatedTime += timeForImage; // fallback
                }
            });
        } else {
            estimatedTime = timeForImage;
        }

        console.log(`⏱ [estimateUploadTime] Estimated: ${estimatedTime}ms`);
        return estimatedTime;
    }
}

// Initialize Revision API service
const aiMultistep = new AiMultistep();

$(document).on('click', '.delete-upload', function () {
    const index = $(this).data('index');
    aiMultistep.uploadedFiles.splice(index, 1);
    aiMultistep.renderUploadedFilesUI();
});

$(document).on('click', '.delete-photo', function () {
    const index = $(this).data('index');
    aiMultistep.uploadedPhotos.splice(index, 1);
    aiMultistep.showPhotoArea();
});

$(document).on('click', '#popup-file-uploader-mobile .add-more-area .add-more', function () {
    aiMultistep.showUploadBox();
});

$(document).on('click', '#push-photos', function () {
    aiMultistep.pushPhotos();
});

$(document).on('click', '.upload-tooltip-opener:not(:disabled)', function (e) {
    e.preventDefault();

    aiMultistep.openUploadPopup();
});

//Combine event handlers for close buttons and modal overlays.
$(document).on("click", ".upload-popup .close-button, .upload-popup .modal-overlay, .result-popup .close-popup, .result-popup .modal-overlay", function (e) {
    const modalPopup = $(this).closest(".upload-popup, .result-popup");

    modalPopup.removeClass("-open");
    $("body").removeClass("overflow-hidden");
});

$(document).on("click", ".repeat-upload", function (e) {
    $(SELECTORS.RESULT_POPUP).removeClass('-open');

    aiMultistep.openUploadPopup();
});

//Combine event handlers for close buttons and modal overlays.
$(document).on("click", ".start-progress", function (e) {
    const $button = $(this);
    $button.prop('disabled', true);

    const estimatedUploadTime = aiMultistep.estimateUploadTime();

    const withMinDelay = (promise, minMs) => {
        const delay = new Promise(resolve => setTimeout(resolve, minMs));
        return Promise.all([promise, delay]).then(([result]) => result);
    };

    aiMultistep.showLoader()
        .then(() => {
            aiMultistep.setLoaderUI(1);

            const uploadAnim = aiMultistep.startLoaderAnimation(84, estimatedUploadTime);

            return aiMultistep.sendFilesToServer()
                .then((response) => ({ response, uploadAnim }));
        })
        .then(async ({ response, uploadAnim }) => {
            uploadAnim.stop(84);
            await uploadAnim.promise;

            const applyResult = await aiMultistep.runLoaderSegment(
                94,
                1200,
                aiMultistep.applyAiResponseToForm(response.summary)
            );

            return applyResult; // { defaultStreet, ... }
        })
        .then(async ({ defaultStreet } = {}) => {
            const streetTask = Promise.resolve().then(() => {
                if (!defaultStreet) {
                    console.warn('⚠️ [Chain] defaultStreet is empty');
                    return 0;
                }

                const filled = aiMultistep.updateStreetFieldFromSelect(defaultStreet);
                if (filled) {
                    aiMultistep.filledFields++;
                }
                return filled;
            });

            await aiMultistep.runLoaderSegment(99, 700, withMinDelay(streetTask, 500));
        })
        .then(async () => {
            await aiMultistep.runLoaderSegment(100, 300, withMinDelay(Promise.resolve(true), 300));

            aiMultistep.hideLoader();
            $button.prop('disabled', false);
            $(SELECTORS.MULTISTEP_FORM_DIV).addClass('ai-filled');

            aiMultistep.replaceAiBox();
            aiMultistep.openResultPopup(true);
        })
        .catch(error => {
            console.error('❌ [Chain] Error:', error);

            // зупинити можливу анімацію
            aiMultistep.stopLoaderAnimation();

            aiMultistep.updateProgress(100, 300);
            setTimeout(() => {
                aiMultistep.hideLoader();
                $button.prop('disabled', false);

                aiMultistep.openResultPopup();
                aiMultistep.updateProgress(0, 0, '');
            }, 300);
        });
});

$(document).on('change', 'input[name="uploaderApprove"]', (e) => {
    if (!$(e.currentTarget).is(':checked')) {
        $('#upload-tooltip-opener').attr('disabled', 'disabled');
    } else {
        $('#upload-tooltip-opener').removeAttr('disabled');
    }
})

$(document).on('change', '.ai-changed input, .ai-changed select', (e) => {
    const $target = $(e.currentTarget);
    const $container = $target.closest('.ai-changed');
    const $pseudoFilled = $container.find('.pseudo-filled');

    if($target.is('input')) {
        if ($pseudoFilled.length > 0) {
            const originalValue = $pseudoFilled.text();
            const currentValue = $target.val();

            if (originalValue !== currentValue) {
                $pseudoFilled.remove();
                $container.removeClass('ai-changed');
                $container.addClass('manually-changed');
            }
        }
    } else {
        $container.removeClass('ai-changed');
        $container.addClass('manually-changed');
    }
})

$(document).on('change', '.ai-required:not(.ai-changed) input, .ai-required:not(.ai-changed) select', (e) => {
    const $target = $(e.currentTarget);
    const $container = $target.closest('.ai-required');
    const inputValue = $target.val();

    // special check for <select>
    if ($target.is('select')) {
        const hasMatchingOption = $target.find(`option[value="${inputValue}"]`).length > 0;
        if (inputValue && hasMatchingOption) {
            $container.removeClass('ai-required');
        }
    } else {
        if (inputValue) {
            $container.removeClass('ai-required');
        }
    }
});
